var AvailablePaymentOptionsModel = (function (Backbone) {
    var AvailablePaymentOptions = Backbone.Collection.extend({
        model: Backbone.Model,

        isOptionApplicable: function (targetPaymentOption) {
            if (!!targetPaymentOption) {
                var paymentOption = targetPaymentOption.toLowerCase();
                return this.models.some(function (option) {
                    return option.get('Name').toLowerCase() === paymentOption;
                });
            }

            return false;
        }
    });

    return AvailablePaymentOptions;
})(Backbone);